import React from "react";
import useHeaderDataStatus from "../../../../components/hooks/useHeaderDataStatus";
import { MdOutlineCheck } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import WrapperLoader from "../../../../components/spinner/WrapperLoader";

function CombineData({
  clientProgressData,
  scriptPresentData,
  scriptPresentDataIsLoading,
}) {
  const isCombineDataFound =
    scriptPresentData?.files?.["combine_data.py"]?.file_name;
  return (
    <div
      title={!isCombineDataFound && "Script is missing"}
      className={
        scriptPresentDataIsLoading
          ? "text-gray-400"
          : !isCombineDataFound && "text-red-400"
      }
    >
      <div>Combine Data</div>
      <WrapperLoader isLoading={scriptPresentDataIsLoading}></WrapperLoader>
      {/* <div className="flex justify-center">
        <WrapperLoader isLoading={scriptPresentDataIsLoading}>
          {isCombineDataFound ? (
            <MdOutlineCheck color="green" size={16} />
          ) : (
            <IoCloseOutline color="red" size={16} />
          )}
        </WrapperLoader>
      </div> */}
    </div>
  );
}

export default CombineData;
